import { render } from "./PwaInstallPrompt.vue?vue&type=template&id=7a8667c0&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=js"

import "./PwaInstallPrompt.vue?vue&type=style&index=0&id=7a8667c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8667c0"]])

export default __exports__